import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'libs/shared/src/lib/services/helpers.service';
import { GrowthBook } from "@growthbook/growthbook";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';

declare var $: any;
@Component({ standalone: false,
  selector: 'vfa-cp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  public title = 'customer-portal';
  private messageRetrieved = new BehaviorSubject(false);
  public maintenance: any;
  private maintenanceModalOpened: boolean = false;
  public appTranslated: boolean = false;
  public message: string = "";
  public headerFixed: boolean = false;

  @ViewChild('maintenanceModal') maintenanceModal: any;

  @HostListener('window:scroll') onScrollEvent() {
    if (window.scrollY > 116) {
      this.headerFixed = true;
    } else if (window.scrollY <= 116) {
      this.headerFixed = false;
    }
  }

  @HostListener('document:click', ['$event']) onDocumentClick(event: any) {
    const classlist = Array.from(event.target.classList);
    this.headerLanguageSelectCloseOutside(classlist);
  }

  constructor(public translate: TranslateService,
    public helpersService: HelpersService,
    private router: Router,
    private modalService: NgbModal,
    @Inject(DOCUMENT) private document: Document) {
    this.router.events.subscribe((e) => {
      if (e instanceof ActivationStart) {
        this.helpersService.navigateTo = e.snapshot.data["navigateTo"];
        this.helpersService.arrowIcon = e.snapshot.data["arrow"];
        this.helpersService.notHelp = e.snapshot.data["notHelp"];
        this.helpersService.headerType = e.snapshot.data["headerType"];
        this.helpersService.bell = e.snapshot.data["bell"];
        this.helpersService.navLogo = e.snapshot.data["navLogo"];
        this.helpersService.noFooter = e.snapshot.data["noFooter"];
        this.helpersService.isHome = e.snapshot.data["isHome"];
        this.helpersService.isRenewal = e.snapshot.data["isRenewal"];
        this.helpersService.isLegacy = e.snapshot.data["isLegacy"];
        this.helpersService.notWizard = e.snapshot.data["notWizard"];
      }
    });
  }

  ngOnInit(): void {
    if (this.helpersService.config.ONE_TRUST_SCRIPT) {
      const sLoadThis = $(this.helpersService.config.ONE_TRUST_SCRIPT);
      for (let oScript of sLoadThis) {
        $("head").append(oScript);
      }
    }
    this.helpersService.setLanguageWebapp();
    this.helpersService.checkUserState();
    if(this.helpersService.config.GROWTHBOOK_ENABLED) {
      this.initGrowthBook();
    }
    this.appTranslateListener();
    const url = (document.getElementsByTagName('base')[0] || {}).href.replace(/(^\w+:|^)\/\//, '').replace(/\/$/, "");
    // const url = 'test-vfacustomerportal.np.automotive.vodafone.com/vfacustomerportal'
    this.helpersService.getSettings(url).subscribe((res) => {
      this.helpersService.applyTheme(res.settings);
    }, err => {
      this.helpersService.applyThemeDefault();
    })
  }

  private async initGrowthBook() {
    const url = (document.getElementsByTagName('base')[0] || {}).href;
    const gb = new GrowthBook({
      apiHost: this.helpersService.config.GROWTHBOOK_API_HOST,
      clientKey: this.helpersService.config.GROWTHBOOK_CLIENT_KEY,
      enableDevMode: true,
      // backgroundSync: false,
      // subscribeToChanges: false,
      attributes: {
        loggedIn: this.helpersService.storageAccessToken ? true : false,
        url: url
      },
      // trackingCallback: (experiment: any, result: any) => {
      //   console.log("Experiment Viewed", {
      //     experimentId: experiment.key,
      //     variationId: result.key,
      //   });
      // },
    });
    await gb.loadFeatures({ autoRefresh: true });
    // const maintenance = gb.getFeatureValue("maintenance", null);
    // console.log(maintenance)
    // setInterval(() => {
    //   gb.refreshFeatures();
    // }, 3000);
    this.onMaintenance(gb);
    gb.setRenderer(() => {
      this.onMaintenance(gb);
    });
  }

  private onMaintenance(gb: GrowthBook) {
    this.maintenance = gb.getFeatureValue(this.helpersService.config.GROWTHBOOK_MAINTENANCE_FEATURE, null);
    if(this.maintenance) {
      const maintenanceBody = {
        label: this.maintenance.label,
        language: this.helpersService.lang,
        fallbackLanguage: "en_GB"
      }
      this.helpersService.getMaintenanceTranslation(maintenanceBody).subscribe(res => {
        this.message = res.message;
        if(this.maintenance.metadata && this.message) {
          const variables = Object.keys(this.maintenance.metadata);
          const today = new Date();
          if(today < new Date(this.maintenance.metadata.startDate) || today > new Date(this.maintenance.metadata.endDate)) { return; }
          if(variables.length) {
            for(let v of variables) {
              const stringToReplace = "{{" + v + "}}";
              if(this.message.includes(stringToReplace)) {
                if(v === "startDate" || v === "endDate") {
                  const stringReplaced = this.message.replace(stringToReplace, moment(this.maintenance.metadata[v]).locale(this.helpersService.lang).format("lll"));
                  this.message = stringReplaced;
                } else {
                  const stringReplaced = this.message.replace(stringToReplace, this.maintenance.metadata[v]);
                  this.message = stringReplaced;
                }
              }
            }
          }
        }
        this.messageRetrieved.next(true);
      }, err => {
        console.log(err);
      })
    }
  }

  private appTranslateListener() {
    this.helpersService.translated.subscribe(translated => {
      if(translated) {
        this.appTranslated = translated;
        if(this.helpersService.config.GROWTHBOOK_ENABLED) {
          this.maintenanceModaleListener();
        }
      }
    })
  }

  private maintenanceModaleListener() {
    this.messageRetrieved.subscribe(messageExists => {
      if(messageExists) {
        if(!this.maintenanceModalOpened && (!this.helpersService.maintenanceMessage || (this.helpersService.maintenanceMessage && this.helpersService.maintenanceMessage !== this.message))) {
          this.modalService.open(this.maintenanceModal, { keyboard: false, backdrop: 'static', centered: true, size: 'md', backdropClass: "bg-modal" });
          this.maintenanceModalOpened = true;
        }
      }
    })
  }

  public closeModal() {
    sessionStorage.setItem( this.helpersService.storageMaintenanceMessageKey, this.message);
    this.modalService.dismissAll();
  }

  private headerLanguageSelectCloseOutside(classlist: any) {
    if(classlist.length) {
      let found = false;
      for(let i = 0; i < classlist.length; i++) {
        if(classlist[i] === "language-select" || classlist[i] === "language-select-button") {
          found = true;
          break;
        }
      }
      if(!found) {
        this.helpersService.headerLangClicked = false;
      }
    } else {
      this.helpersService.headerLangClicked = false;
    }
  }

  ngOnDestroy() {
    this.helpersService.translated.unsubscribe();
    this.messageRetrieved.unsubscribe();
  }
}

